import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M20 5.4L18.6 4 12 10.6 5.4 4 4 5.4l6.6 6.6L4 18.6 5.4 20l6.6-6.6 6.6 6.6 1.4-1.4-6.6-6.6L20 5.4z", clipRule: "evenodd" }));
export {
  o as ReactComponent
};
